export default "__VITE_ASSET__f1Gzqe3L__"